/***
 * dispatch 方法用于异步调用 store 状态中的 action 方法，更新state中的数据列表
 * isAync === true 则直接调用 dispath, 反正则 获取 getter中的数据，为空在调用dispatch
 * path为路径，list 为要调用的 action
 *
 * 注意：该方法必须用于 state, getter，mutation，action中的方法名是必须一样的
 * 注意：具体请看 store/muodules/common 文件的 marketplace 状态
 */
// import { useStore } from 'vuex'
// const store = useStore()

export function dispatch(store, param) {
  const { isAync, path, list } = param
  //   return console.log(store, isAync, path, list)
  // 多个异步调用
  if (Array.isArray(list)) {
    //   多个路径
    if (Array.isArray(path)) {
      path.forEach((vPath) => {
        list.forEach((ele) => {
          doDispatch(store, isAync, `${vPath}/${ele}`)
        })
      })
    } else {
      // 单个路径
      list.forEach((ele) => {
        doDispatch(store, isAync, `${path}/${ele}`)
      })
    }
  }
  if (Object.prototype.toString.call(param.list) === '[object String]') {
    doDispatch(store, isAync, `${path}/${list}`)
  }
}

function doDispatch(store, isAync, path) {
  if (isAync) {
    store.dispatch(`${path}`)
  } else {
    let len = store.getters[`${path}`].length
    len === 0 && store.dispatch(`${path}`)
  }
}

export const marketplaceList = [
  { label: '美国', value: 'us' },
  { label: '加拿大', value: 'ca' },
  { label: '墨西哥', value: 'mx' },
  { label: '英国', value: 'uk' },
  { label: '德国', value: 'de' },
  { label: '波兰', value: 'pl' },
  { label: '澳大利亚', value: 'au' },
  { label: '意大利', value: 'it' },
  { label: '西班牙', value: 'es' },
  { label: '法国', value: 'fr' },
  { label: '土耳其', value: 'tr' },
]
